import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endpoints from "../../endpoint";

// Thunk to fetch all experts
export const fetchExperts = createAsyncThunk(
  "experts/fetchAll",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endpoints.serverBaseUrl}api/experts`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching experts:", error.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Async thunk to handle the follow expert API request
export const followExpert = createAsyncThunk(
  "experts/followExpert",
  async ({ expertId, userId }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${endpoints.serverBaseUrl}api/experts/${expertId}/follow`,
        { userId },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Follow API error:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk to fetch a single expert by ID
export const fetchExpertById = createAsyncThunk(
  "experts/fetchById",
  async (expertId, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endpoints.serverBaseUrl}api/experts/${expertId}`
        , {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching expert by ID:", error.message);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Slice
const expertsSlice = createSlice({
  name: "experts",
  initialState: {
    experts: [],
    selectedExpert: null,
    followedExperts: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch all experts
      .addCase(fetchExperts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExperts.fulfilled, (state, action) => {
        state.loading = false;
        state.experts = action.payload;
      })
      .addCase(fetchExperts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Follow/unfollow expert
      .addCase(followExpert.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(followExpert.fulfilled, (state, action) => {
        state.loading = false;
        const { expertId, isFollowing, followersCount } = action.payload;

        // Update expert list
        state.experts = state.experts.map((expert) =>
          expert._id === expertId
            ? { ...expert, followers: followersCount }
            : expert
        );

        // Update selected expert if viewing individual expert
        if (state.selectedExpert?._id === expertId) {
          state.selectedExpert.followers = followersCount;
        }
      })
      .addCase(followExpert.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      // Fetch single expert
      .addCase(fetchExpertById.pending, (state) => {
        state.loading = true;
        state.selectedExpert = null;
        state.error = null;
      })
      .addCase(fetchExpertById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedExpert = action.payload;
      })
      .addCase(fetchExpertById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default expertsSlice.reducer;
